import Hero from "./sections/hero/hero";
import Loader from "./loader/loader";
import Slider from "./sections/slider/slider";
import { useEffect, useState } from "react";
import Blog from "./sections/blog/blog";
import SliderMob from "./sections/sliderMob/sliderMob";

let disable = false;

function easeIn(t) {
  return t * t;
}

function smoothScroll(section) {
  const section2Top = section.offsetTop;
  const initialTop = window.pageYOffset;
  const difference = section2Top - initialTop;

  let start;

  function step(timestamp) {
    if (!start) start = timestamp;
    const progress = (timestamp - start) / 1000;
    const easedProgress = easeIn(progress);
    window.scrollTo(0, initialTop + difference * easedProgress);
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  }

  window.requestAnimationFrame(step);
}

export default function App() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [mob, setMob] = useState(window.innerWidth < 650);

  const [data, setData] = useState([]);

  const [heroData, setHeroData] = useState([]);

  useEffect(() => {
    const initLoad = () => {
      fetch(process.env.PUBLIC_URL + "/json/slider.json")
        .then((res) => res.json())
        .then((data) => {
          setData([...data]);
        });
    };

    initLoad();

    fetch(process.env.PUBLIC_URL + "/json/hero.json")
      .then((res) => res.json())
      .then((data) => {
        setHeroData([...data]);
      });
  }, []);

  useEffect(() => {
    const resize = () => {
      setWindowWidth(window.innerWidth);

      if (window.innerWidth < 650) {
        setMob(true);
      } else {
        setMob(false);
      }
    };

    resize();

    window.addEventListener("resize", resize);

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  useEffect(() => {
    if ((windowWidth <= 650 && !mob) || (windowWidth > 650 && mob)) {
      window.location.reload();
    }
  }, [windowWidth, mob]);

  useEffect(() => {
    const handleBeforeUnload = () => {
      document.body.style.opacity = "0";
      window.scrollTo(0, 0);
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const handleScroll = function (event) {
      if (disable) return;

      if (section3.scrollTop > 100) {
        return;
      }

      if (section1.scrollTop < 200 && activeIndex === 0) {
        return;
      }

      disable = true;

      setTimeout(() => {
        disable = false;
      }, 2000);

      if (event.deltaY < 0) {
        switch (activeIndex) {
          case 0:
            return;
          case 1:
            setActiveIndex(0);
            return smoothScroll(section1);
          case 2:
            return setActiveIndex(1);
          case 3:
            return setActiveIndex(2);
          case 4:
            return setActiveIndex(3);
          case 5:
            return setActiveIndex(4);
          case 6:
            return setActiveIndex(5);
          case 7:
            return setActiveIndex(6);
          case 8:
            setActiveIndex(7);
            return smoothScroll(section2);
          default:
            return;
        }
      } else if (event.deltaY > 0) {
        switch (activeIndex) {
          case 0:
            setActiveIndex(1);

            setTimeout(() => {
              // section1.scrollTo(0, 0);
            }, 1000);

            return smoothScroll(section2);
          case 1:
            return setActiveIndex(2);
          case 2:
            return setActiveIndex(3);
          case 3:
            return setActiveIndex(4);
          case 4:
            return setActiveIndex(5);
          case 5:
            return setActiveIndex(6);
          case 6:
            return setActiveIndex(7);
          case 7:
            setActiveIndex(8);
            return smoothScroll(section3);
          default:
            return;
        }
      }
    };

    if (window.innerWidth <= 650) {
      window.removeEventListener("wheel", handleScroll);

      return;
    }

    const section1 = document.querySelector("#section1");
    const section2 = document.querySelector("#section2");
    const section3 = document.querySelector("#section3");

    window.addEventListener("wheel", handleScroll);

    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, [activeIndex]);

  const instantScroll = () => {
    const section3 = document.querySelector("#section3");

    setActiveIndex(8);
    return smoothScroll(section3);
  };

  const instantScrollUp = () => {
    const section1 = document.querySelector("#section1");

    setActiveIndex(0);
    return smoothScroll(section1);
  };

  const scrollToAbout = () => {
    const section1 = document.querySelector("#section1");
    const section2 = document.querySelector("#section2");

    setActiveIndex(1);

    setTimeout(() => {
      section1.scrollTo(0, 0);
    }, 1000);

    return smoothScroll(section2);
  };

  return (
    <>
      <div className="scroll-body">
        <Loader />

        <Hero
          activeIndex={activeIndex}
          scrollToAbout={scrollToAbout}
          instantScroll={instantScroll}
          data={heroData}
        />

        {mob ? (
          <SliderMob
            data={data}
            instantScroll={instantScroll}
            instantScrollUp={instantScrollUp}
          />
        ) : (
          <Slider
            index={activeIndex}
            instantScroll={instantScroll}
            instantScrollUp={instantScrollUp}
            data={data}
          />
        )}

        <Blog />
      </div>
    </>
  );
}
